import './App.css';
import {
  AppBar,
  Box,
  Container,
  CssBaseline,
  List,
  ListItem,
  Paper,
  Toolbar,
  Typography,
  Link,
} from "@mui/material";
import { Helmet } from 'react-helmet';

const appItems = [
  {
    title: "Telegram Bots",
    href: "/telegram",
    description: "Telegram bot hook.",
  },
  {
    title: "Nginx",
    href: "/nginx",
    description: "Nginx config file creator.",
  },
  {
    title: "Password Generator",
    href: "/password",
    description: "Password generator.",
  },
];

function App() {
  return (
    <>
      <Helmet>
        <title>Redmorus</title>
        <meta name="description" content="Welcome to Redmorus modern application index. Effortless control, simplified workflow." />
      </Helmet>
      <CssBaseline />

      {/* Header */}
      <AppBar position="static" sx={{ backgroundColor: "#00bcd4" }}>
        <Toolbar>
          <Typography variant="h5" component="div" sx={{ flexGrow: 1, textAlign: "center" }}>
            Redmorus Application
          </Typography>
        </Toolbar>
      </AppBar>

      {/* Content */}
      <Container maxWidth="md" sx={{ my: 4 }}>
        <Paper elevation={3} sx={{ p: 4, borderRadius: 2 }}>
          <Typography variant="h5" fontWeight={"bold"} gutterBottom sx={{ color: "#007bff", textAlign: "center" }}>
            Applications
          </Typography>

          <List disablePadding>
            {appItems.map((item, index) => (
              <ListItem
                key={index}
                sx={{
                  mb: 2,
                  borderRadius: 2,
                  backgroundColor: "#f9f9f9",
                  boxShadow: 1,
                  transition: "background-color 0.3s",
                  "&:hover": { backgroundColor: "#e9ecef" },
                  display: "block",
                }}
              >
                <Link href={item.href} underline="none" color="inherit" fontWeight="bold">
                  {item.title}
                </Link>
                <Typography variant="body2" sx={{ mt: 1, color: "#666666" }}>
                  {item.description}
                </Typography>
              </ListItem>
            ))}
          </List>
        </Paper>
      </Container>

      {/* Footer */}
      <Box
        component="footer"
        sx={{
          py: 2,
          px: 2,
          mt: "auto",
          backgroundColor: "#00bcd4",
          color: "white",
          textAlign: "center",
          position: "fixed",
          bottom: 0,
          width: "100%",
        }}
      >
        <Typography variant="body2">&copy; 2024 Redmorus. All rights reserved.</Typography>
      </Box>
    </>
  );
}

export default App;
